<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="appointment-item module-item module-item-wrap"
    @click="$emit('click')"
  >
    <span
      class="absolute-top-right triangle"
      :style="{'color': fieldColor}"
    />

    <q-item-section>
      <div class="flex justify-between q-gutter-sm">
        <div
          v-if="withColor"
          style="flex: 0 0 20px"
          class="self-center"
        >
          <span
            class="dot inline-block"
            :style="{'background-color': appointment.color}"
          />
        </div>

        <div style="flex: 1 0 150px;">
          <q-item-label color="blue-9" :lines="2">
            <q-item-label>
              <span class="module-name" :title="appointment.title">{{ appointment.title }}</span>

              <template v-if="appointment.types">
                <q-chip
                  v-for="(type, key) in appointment.types"
                  :key="key"
                  :title="type.name"
                  dense
                  square
                  color="grey-3"
                  size="10px"
                  class="q-my-none q-mx-xs"
                >
                  {{ truncateString(type.shorthand_name || type.name, 35) }}
                </q-chip>
              </template>
            </q-item-label>

            <q-item-label caption>
              ({{ truncateString(appointment.reference_id, 20) }})
            </q-item-label>
          </q-item-label>

          <q-item-label
            v-if="appointment.address"
            caption
            :lines="2"
          >
            {{ appointment.address.full_address }}
          </q-item-label>
        </div>

        <q-item-label
          v-if="!dense"
          caption
          style="flex: 0 1 175px;"
        >
          <DateTimePartial
            :is-scheduled="appointment.status !== 'UNSCHEDULED'"
            :all-day="appointment.all_day"
            :start-date="appointment.start_date"
            :end-date="appointment.end_date"
            :timezone="appointment.timezone_details"
            without-length
          />
        </q-item-label>
      </div>
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
      @click="onSideClick"
    >
      <slot />
    </q-item-section>

    <slot name="outer" />
  </q-item>
</template>

<script>
/*
  Partial to display appointment information on any page
*/
import DateTimePartial from './DateTime'
import statusMixin from './mixins/statusMixin'
import itemMixin from 'src/helpers/item'

export default {
  components: {
    DateTimePartial
  },
  mixins: [itemMixin, statusMixin],
  props: {
    appointment: {
      required: true,
      type: Object
    },
    withColor: {
      type: Boolean,
      default: false
    },
    preventSideClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fieldColor () {
      return this.baseFieldColor(this.appointment.status)
    },
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  methods: {
    onSideClick (e) {
      if (this.preventSideClick) {
        e.stopPropagation()
      }
    }
  }
}
</script>
